import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {makeStyles} from '@material-ui/core/styles'
import {
    Box,
    CssBaseline,
    Drawer,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemSecondaryAction,
    Typography,
    Fade,
    Slide,
} from '@material-ui/core'
import FolderIcon from '@material-ui/icons/Folder'
import EditIcon from '@material-ui/icons/Edit'
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined'
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder'

import {connect} from 'react-redux'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import {dataActions} from '../../../actions'

import CategoryDrawer from './EventCategory/CategoryDrawer'

const drawerWidth = '23rem'

// using hook API
const useStyles = makeStyles(theme => ({
    root: {
        display: '-webkit-flexbox',
        maxHeight: '93vh',
        overflowX: 'hidden',
        backgroundColor: '#F4F8F8',
    },
    iconButtonOpen: {
        height: '3rem',
        width: '2.0rem',
        minWidth: '1.5rem',
        position: 'fixed',
        top: '90px',
        left: '-4px',
        backgroundColor: theme.palette.green.medium,
        '&:hover': {
            backgroundColor: theme.palette.green.light,
        },
    },
    iconButton: {
        padding: 10,
        backgroundColor: '#F4F8F8',
        '&:hover': {
            opacity: '0.8',
            backgroundColor: '#F4F8F8',
        },
        transition: theme.transitions.create(['transform'], {
            duration: theme.transitions.duration.shortest,
        }),
    },
    drawer: {
        width: drawerWidth,
    },
    drawerPaper: {
        display: '-webkit-box',
        width: drawerWidth,
        position: 'relative',
        border: 'none',
        backgroundColor: '#F4F8F8',
    },
    unselected: {
        borderLeft: '5px solid transparent',
    },
    selected: {
        borderLeft: '5px solid #02AB77',
    },
    drawerOpen: {
        transform: 'rotate(180deg)',
    },
    editCategory: {
        position: 'relative',
        zIndex: 100,
        left: '10px',
    },
    viewArchiveButton: {
        marginLeft: '12px',
        fontSize: '0.8rem',
        color: '#707070',
        '&:hover': {
            color: theme.palette.green.medium,
            backgroundColor: 'transparent',
        },
    },
}))

const EventCategory = props => {
    const classes = useStyles()
    const {
        token,
        currenteventcategory,
        eventcategorylist,
        fetchingEventCategory,
        setEventcategory,
        getEventOccurrences,
        open,
        handleDrawerOpen,
        handleDrawerClose,
    } = props

    const {id: evtId, deptId} = currenteventcategory
    const activeEventCategory = `${evtId ? evtId : ''}${deptId ? deptId : ''}`

    const [openDialog, setOpenDialog] = useState(false)
    const [title, setTitle] = useState(' ')
    const [status, setStatus] = useState('A')

    // * Important!!! Always create a new instance of a Redux global object to avoid mutating the store between dispatches
    const eventcategorysorted = [...eventcategorylist]

    eventcategorysorted.sort((a, b) => (a.name > b.name ? 1 : -1))

    const viewEventCategoryList = eventcategorysorted
        ? eventcategorysorted.filter(category => category.status === status)
        : []

    const archiveCategoryExists = eventcategorysorted
        ? eventcategorysorted.filter(category => category.status === 'I')
        : []

    let buttoncomponent

    const handleClickOpen = title => {
        setOpenDialog(true)
        setTitle(title)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    const handleToggleStatus = status => {
        setStatus(status)
    }

    useEffect(() => {
        if (activeEventCategory.length > 0) {
            getEventOccurrences(token, currenteventcategory)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    switch (status) {
        case 'A':
            buttoncomponent = archiveCategoryExists.length > 0 && (
                <Button
                    variant="text"
                    aria-label="view archive categories"
                    onClick={() => handleToggleStatus('I')}
                    size="large"
                    className={classes.viewArchiveButton}
                >
                    View Archive Categories
                </Button>
            )
            break
        case 'I':
            buttoncomponent = (
                <Button
                    variant="text"
                    aria-label="view active categories"
                    onClick={() => handleToggleStatus('A')}
                    size="large"
                    className={classes.viewArchiveButton}
                >
                    View Active Categories
                </Button>
            )
            break
        default:
            buttoncomponent = <div>Invalid option</div>
    }

    return (
        <>
            <CssBaseline />
            <div className={classes.root}>
                {!open && (
                    <Fade in={true} mountOnEnter unmountOnExit timeout={400}>
                        <Button
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => handleDrawerOpen()}
                            edge="start"
                            className={classes.iconButtonOpen}
                        >
                            <ChevronRightIcon
                                style={{color: '#FFFFFF', fontSize: '2.5rem'}}
                            />
                        </Button>
                    </Fade>
                )}
                <Slide direction="right" in={open} mountOnEnter unmountOnExit>
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={open}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            style={{padding: '7% 0 0 0'}}
                            width="23rem"
                        >
                            <Box>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    flexDirection="row"
                                    justifyContent="space-between"
                                    style={{paddingLeft: '32px'}}
                                >
                                    <Typography
                                        variant="h5"
                                        style={{color: '#000000'}}
                                    >
                                        {status === 'A'
                                            ? 'Event Category'
                                            : 'Archive Category'}
                                    </Typography>
                                    <IconButton
                                        className={clsx(
                                            classes.iconButton,
                                            !open && classes.drawerOpen
                                        )}
                                        onClick={() => handleDrawerClose()}
                                    >
                                        <ChevronLeftIcon
                                            style={{fontSize: '2.5rem'}}
                                        />
                                    </IconButton>
                                </Box>

                                {eventcategorylist.length ? (
                                    <>
                                        <List>
                                            {viewEventCategoryList.map(
                                                eventcat => {
                                                    const listitemKey =
                                                        eventcat.id.toString() +
                                                        eventcat.deptId.toString()
                                                    const listitemSelected =
                                                        activeEventCategory ===
                                                        listitemKey
                                                            ? true
                                                            : false
                                                    const payload = listitemSelected
                                                        ? {}
                                                        : {
                                                              eventcat,
                                                              token,
                                                          }

                                                    return (
                                                        <ListItem
                                                            button
                                                            className={
                                                                listitemSelected
                                                                    ? classes.selected
                                                                    : classes.unselected
                                                            }
                                                            key={listitemKey}
                                                            disabled={
                                                                fetchingEventCategory
                                                            }
                                                            selected={
                                                                listitemSelected
                                                            }
                                                            onClick={() =>
                                                                setEventcategory(
                                                                    payload
                                                                )
                                                            }
                                                        >
                                                            <ListItemIcon>
                                                                {listitemSelected ? (
                                                                    <FolderIcon
                                                                        style={{
                                                                            marginLeft:
                                                                                '15px',
                                                                            color:
                                                                                '#098447',
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <FolderOutlinedIcon
                                                                        style={{
                                                                            marginLeft:
                                                                                '15px',
                                                                            opacity: 0.8,
                                                                        }}
                                                                    />
                                                                )}
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                primary={
                                                                    eventcat.name
                                                                }
                                                                primaryTypographyProps={{
                                                                    variant:
                                                                        'body1',
                                                                    style: {
                                                                        fontWeight: listitemSelected
                                                                            ? '700'
                                                                            : '400',
                                                                    },
                                                                }}
                                                            />
                                                            {listitemSelected && (
                                                                <ListItemSecondaryAction>
                                                                    <ListItemIcon>
                                                                        <IconButton
                                                                            className={
                                                                                classes.editCategory
                                                                            }
                                                                            onClick={() =>
                                                                                handleClickOpen(
                                                                                    'Edit Event Category'
                                                                                )
                                                                            }
                                                                        >
                                                                            <EditIcon
                                                                                style={{
                                                                                    color:
                                                                                        '#098447',
                                                                                }}
                                                                            />
                                                                        </IconButton>
                                                                    </ListItemIcon>
                                                                </ListItemSecondaryAction>
                                                            )}
                                                        </ListItem>
                                                    )
                                                }
                                            )}
                                            <ListItem>
                                                {buttoncomponent}
                                            </ListItem>
                                        </List>
                                    </>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        style={{
                                            padding: '20px 32px',
                                            color: '#000000',
                                        }}
                                    >
                                        We couldn’t find any event categories
                                        assigned to this department. Use the
                                        CREATE CATEGORY button to add new event
                                        categories.
                                    </Typography>
                                )}
                            </Box>
                            <Box
                                style={{
                                    alignSelf: 'center',
                                    margin: '0 0 15px 0',
                                    width: '80%',
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    aria-label="create new category"
                                    onClick={() =>
                                        handleClickOpen('Create Event Category')
                                    }
                                    //edge="start"
                                    size="large"
                                    startIcon={
                                        <CreateNewFolderIcon
                                            style={{color: '#098447'}}
                                        />
                                    }
                                    style={{width: '100%'}}
                                >
                                    Create Category
                                </Button>
                            </Box>
                        </Box>
                    </Drawer>
                </Slide>

                <CategoryDrawer
                    title={title}
                    openDialog={openDialog}
                    handleCloseDialog={handleCloseDialog}
                    handleToggleStatus={handleToggleStatus}
                />
            </div>
        </>
    )
}

EventCategory.propTypes = {
    token: PropTypes.string.isRequired,
    eventCategorylist: PropTypes.object,
    fetchingEventCategory: PropTypes.bool,
    setEventcategory: PropTypes.func.isRequired,
    open: PropTypes.bool,
    handleDrawerOpen: PropTypes.func.isRequired,
    handleDrawerClose: PropTypes.func.isRequired,
    currenteventcategory: PropTypes.object,
}

function mapStateToProps(state) {
    return {
        eventcategorylist: state.eventcategorydata.eventCategorylist,
        fetchingEventCategory: state.eventcategorydata.fetchingEventCategory,
        token: state.authentication.token,
        currenteventcategory: state.seteventcategorydata.eventcategory,
    }
}

const mapDispatchToProps = {
    setEventcategory: payload => dataActions.eventcategorySetRequest(payload),
    getEventOccurrences: (token, activeEventCategory) =>
        dataActions.eventoccurGetRequest({token, activeEventCategory}),
}

export default connect(mapStateToProps, mapDispatchToProps)(EventCategory)
